<template>
    <div class="margin" v-if="renderize">
        <form id="form-editar-infoscadastrais" @submit.prevent="updateProfile">
        <section class="row">
            <div class="tit col-12">
                <h2>Edite suas informações</h2>
            </div>
        </section>
        <section class="row">
            <div class="col-12">
                <h3>Informações pessoais</h3>
            </div>

            <div class="col-12">
                    <div class="row">
                        <div class="col-12">
                            <label for="email">E-mail</label>
                            <input type="email" class="form-control form-control-lg" id="email" placeholder="Email" v-model="investorProfile.Email" disabled>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-8">
                            <label for="nome">Nome completo</label>
                            <input required type="text" class="form-control form-control-lg" id="nome" v-bind:style="[ fullNameError ? { 'border-color': 'red'} : { 'border-color': 'none' } ]" @keyup="validateFullName()" placeholder="Nome completo" v-model="investorProfile.NomeCompleto">
                        </div>
                        <div class="col-12 col-lg-4">
                            <label for="investorProfile.Sexo">Sexo</label>
                            <at-select v-model="investorProfile.Sexo" name="sexo" id="sexo" size="large">
                                <at-option :value="2">Feminino</at-option>
                                <at-option :value="1">Masculino</at-option>
                            </at-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <label for="estado-civil">Estado civil</label>
                            <at-select v-model="investorProfile.EstadoCivil" name="estado-civil" id="estado-civil" size="large">
                                <at-option :value="1">Solteiro(a)</at-option>
                                <at-option :value="2">Casado(a)</at-option>
                                <at-option :value="3">Separado(a)</at-option>
                                <at-option :value="4">Viúvo(a)</at-option>
                                <at-option :value="5">União estável</at-option>
                            </at-select>
                        </div>
                        <div class="col-12 col-lg-9">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <label for="nome-mae">Nome da mãe</label>
                                    <input required @keyup="validateMothersName()" v-model="investorProfile.NomeMae" type="text" id="nome-mae" class="form-control form-control-lg" value="Diva Angêla de Oliveira Macedo">
                                </div>
                                <div class="col-12 col-lg-6">
                                    <label for="nome-pai">Nome do pai</label>
                                    <input required @keyup="validateFathersName()" v-model="investorProfile.NomePai" type="text" id="nome-pai" class="form-control form-control-lg" value="Mario de Moreira Macedo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <label for="tel-fixo">Telefone fixo</label>
                            <input v-model="investorProfile.TelefoneFixo" type="text" id="tel-fixo" class="form-control form-control-lg" placeholder="(00) 0000-0000" v-mask="'phone'">
                        </div>
                        <div class="col-12 col-lg-6">
                            <label for="tel-celular">Telefone celular</label>
                            <input required v-model="investorProfile.Celular" type="text" id="tel-celular" class="form-control form-control-lg" placeholder="(00) 00000-0000" v-mask="'phone'">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <label for="cpf">CPF</label>
                            <input disabled v-model="investorProfile.Cpf" type="text" id="cpf" class="form-control form-control-lg" placeholder="Seu CPF" v-mask="'cpf'">
                        </div>
                        <div class="col-12 col-lg-6">
                            <label for="nacionalidade">Nacionalidade</label>
                            <at-select ref="nationalitySelect" required v-model="investorProfile.Nacionalidade" name="nacionalidade" id="nacionalidade" size="large" placeholder="Selecione" filterable>
                                <at-option :value="1">Brasileira(o) Nata(o)</at-option>
                                <at-option :value="2">Brasileira(o) Naturalizada(o)</at-option>
                                <at-option :value="3">Estrangeira(o)</at-option>
                            </at-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label for="naturalidade">Estado Onde Nasceu</label>
                            <at-select ref="placeOfBirthSelect" id="naturalidade" v-model="investorProfile.Naturalidade" size="large" placeholder="Selecione" filterable required>
                                <at-option value="Exterior">--Exterior--</at-option>
                                <at-option v-for="state in states" v-bind:key="state.uf" :value="state.nome">{{ state.nome }}</at-option>
                            </at-select>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label for="naturalidade">Cidade Onde Nasceu</label>
                            <input required v-model="investorProfile.NaturalidadeCidade" type="text" id="naturalidade" class="form-control form-control-lg" placeholder="Cidade Onde Nasceu">
                        </div>
                        <div class="col-12 col-lg-4">
                            <label for="data-nasc">Data de Nascimento</label>
                            <input required v-model="investorProfile.DataNascimentoExibicao" type="text" id="data-nasc" format="dd/MM/yyyy" v-mask="'date'" class="form-control form-control-lg" placeholder="dd/mm/aaaa">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <label for="rg">RG</label>
                            <input required v-model="investorProfile.RgNumero" type="text" id="rg" class="form-control form-control-lg" placeholder="0.000.000-00" value="Goioerê/PR">
                        </div>
                        <div class="col-12 col-lg-3">
                            <label for="naturalidade">Orgão Emissor</label>
                            <input required v-model="investorProfile.RgOrgaoEmissor" type="text" id="naturalidade" class="form-control form-control-lg" value="SSP">
                        </div>
                        <div class="col-12 col-lg-3">
                            <label for="estado-emissor">Estado emissor</label>
                            <at-select required v-model="investorProfile.RgEstadoEmissor" name="estado-emissor" id="estado-civil" size="large" filterable>
                                <at-option value="AC">AC</at-option>
                                <at-option value="AL">AL</at-option>
                                <at-option value="AP">AP</at-option>
                                <at-option value="AM">AM</at-option>
                                <at-option value="BA">BA</at-option>
                                <at-option value="CE">CE</at-option>
                                <at-option value="DF">DF</at-option>
                                <at-option value="ES">ES</at-option>
                                <at-option value="GO">GO</at-option>
                                <at-option value="MA">MA</at-option>
                                <at-option value="MT">MT</at-option>
                                <at-option value="MS">MS</at-option>
                                <at-option value="MG">MG</at-option>
                                <at-option value="PA">PA</at-option>
                                <at-option value="PB">PB</at-option>
                                <at-option value="PR">PR</at-option>
                                <at-option value="PE">PE</at-option>
                                <at-option value="PI">PI</at-option>
                                <at-option value="RJ">RJ</at-option>
                                <at-option value="RN">RN</at-option>
                                <at-option value="RS">RS</at-option>
                                <at-option value="RO">RO</at-option>
                                <at-option value="RR">RR</at-option>
                                <at-option value="SC">SC</at-option>
                                <at-option value="SP">SP</at-option>
                                <at-option value="SE">SE</at-option>
                                <at-option value="TO">TO</at-option>
                            </at-select>
                        </div>
                        <div class="col-12 col-lg-3">
                            <label for="data-nasc">Data de Emissão</label>
                            <input required v-model="investorProfile.RgDataEmissaoExibicao" type="text" id="data-nasc" v-mask="'date'" format="dd/MM/yyyy" class="form-control form-control-lg" placeholder="dd/mm/yyyy">
                        </div>
                    </div>
            </div>
        </section>
        <section class="row">
            <div class="col-12">
                <h3>Endereço</h3>
            </div>
            <div class="col-12">
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <label for="cep">CEP</label>
                            <input required @change="handleZipcodeChange" v-model="investorProfile.Endereco.Cep" type="text" id="cep" class="form-control form-control-lg" placeholder="00000-000" pattern="\d{5}-?\d{3}" v-mask="'zipcode'">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                             <label for="endereco">Endereço</label>
                            <input required v-model="investorProfile.Endereco.Logradouro" type="text" id="endereco" class="form-control form-control-lg" placeholder="Endereço" value="Rua José Dambrósio, 49">
                        </div>
                        <div class="col-12 col-lg-3">
                             <label for="numero">Número</label>
                            <input required v-model="investorProfile.Endereco.Numero" type="text" id="numero" class="form-control form-control-lg" placeholder="" value="47">
                        </div>
                        <div class="col-12 col-lg-3">
                            <label for="compl">Complemento</label>
                            <input v-model="investorProfile.Endereco.Complemento" type="text" id="compl" class="form-control form-control-lg" placeholder="" value="Apt 05">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label for="bairro">Bairro</label>
                            <input required v-model="investorProfile.Endereco.Bairro"  type="text" id="bairro" class="form-control form-control-lg" placeholder="" value="Caputera">
                        </div>
                        <div class="col-12 col-lg-4">
                            <label for="estado">Estado</label>
                            <at-select required v-model="investorProfile.Endereco.Uf" filterable name="estado" id="estado-civil" @on-change="onUfChange" size="large">
                                <at-option value="AC">AC</at-option>
                                <at-option value="AL">AL</at-option>
                                <at-option value="AP">AP</at-option>
                                <at-option value="AM">AM</at-option>
                                <at-option value="BA">BA</at-option>
                                <at-option value="CE">CE</at-option>
                                <at-option value="DF">DF</at-option>
                                <at-option value="ES">ES</at-option>
                                <at-option value="GO">GO</at-option>
                                <at-option value="MA">MA</at-option>
                                <at-option value="MT">MT</at-option>
                                <at-option value="MS">MS</at-option>
                                <at-option value="MG">MG</at-option>
                                <at-option value="PA">PA</at-option>
                                <at-option value="PB">PB</at-option>
                                <at-option value="PR">PR</at-option>
                                <at-option value="PE">PE</at-option>
                                <at-option value="PI">PI</at-option>
                                <at-option value="RJ">RJ</at-option>
                                <at-option value="RN">RN</at-option>
                                <at-option value="RS">RS</at-option>
                                <at-option value="RO">RO</at-option>
                                <at-option value="RR">RR</at-option>
                                <at-option value="SC">SC</at-option>
                                <at-option value="SP">SP</at-option>
                                <at-option value="SE">SE</at-option>
                                <at-option value="TO">TO</at-option>
                            </at-select>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label for="cidade">Cidade</label>
                            <at-select required ref="citySelect" v-model="investorProfile.Endereco.Cidade" filterable name="cidade" id="cidade" size="large">
                                <at-option v-for="city of cities" :key="city._id" :value="city.nome">{{ city.nome }}</at-option>
                            </at-select>
                        </div>
                    </div>
            </div>
        </section>
        <section class="row">
            <div class="col-12">
                <h3>Outras informações</h3>
            </div>
            <div class="col-12">
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <label for="renda">Renda mensal aprox. (R$)</label>
                            <input required v-model="investorProfile.RendaMensal" type="text" id="renda" v-mask="'money'" class="form-control form-control-lg" placeholder="" value="R$ 0.000,00">
                        </div>
                        <div class="col-12 col-lg-3">
                            <label for="renda">Patrimômio aprox. (R$)</label>
                            <input required v-model="investorProfile.Patrimonio" type="text" id="renda" v-mask="'money'" class="form-control form-control-lg" placeholder="" value="R$ 00.000,00">
                        </div>
                        <div class="col-12 col-lg-6">
                            <label for="renda">Você é uma pessoa politicamente exposta?</label>
                            <div class="inline-radio">
                                <div class="form-check form-check-inline">
                                    <div class="checkContainer">
                                        <input required v-model="investorProfile.PessoaPoliticamenteExposta" class="form-check-input" type="radio" name="ppe" id="inlineRadio2" :value="true">
                                        <span class="checkmark"></span>
                                        <label class="form-check-label" for="inlineRadio2">Sim, declaro ser PPE.</label>
                                    </div>
                                </div>
                                <div class="form-check form-check-inline">
                                    <div class="checkContainer">
                                        <input required v-model="investorProfile.PessoaPoliticamenteExposta" class="form-check-input" type="radio" name="ppe" id="inlineRadio1" :value="false">
                                        <span class="checkmark"></span>
                                        <label class="form-check-label" for="inlineRadio1">Não, Declaro não ser PPE.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </section>
        <section class="row">
            <div class="col-12">
                <h3>Dados bancários</h3>
            </div>
            <div class="col-12" style="margin-top: 10px;">
              <p>Para solicitar a troca de dados bancários, por favor entre em contato com nossa equipe através do telefone <strong>(11) 4858-0862</strong> ou via e-mail <strong>meajuda@iouu.com.br</strong>.</p>
                    <!-- <div class="text" style="margin-bottom: 30px;">
                        <label v-for="(banco, i) in mainBanks" :key="`mainBank${i}`" class="banco-principal">
                            <input :value="banco.codigo" v-model="investorProfile.DadosBancarios.CodigoBanco" name="banco" type="radio" class="banco-principal-input"/>
                            <img :src="banco.logo" class="banco-principal-logo"/>
                        </label>
                        <label class="banco-principal">
                            <input :checked="isOtherBank" @change="aoMudarEhOutroBanco" type="radio" class="banco-principal-input"/>
                            <img src="/static/assets/images/outro-banco.png" class="banco-principal-logo"/>
                        </label>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label for="logradouro">Banco</label>
                            <at-select v-if="bankRenderizer" ref="bankSelect" filterable v-model="investorProfile.DadosBancarios.CodigoBanco" size="large" placeholder="Banco">
                                <at-option v-for="banco in banks" :key="banco._id" :value="banco.codigo">{{banco.nome}}</at-option>
                            </at-select>
                        </div>
                        <div v-if="investorProfile.DadosBancarios.CodigoBanco == '001'" class="col-12 col-lg-2">
                            <label for="logradouro">Agência</label>
                            <input required key="agency" type="text" class="form-control form-control-lg" v-model="investorProfile.DadosBancarios.Agencia" v-mask="'bank-account-bb'" placeholder="Agência" >
                        </div>
                        <div v-if="investorProfile.DadosBancarios.CodigoBanco == '237'" class="col-12 col-lg-2">
                            <label for="logradouro">Agência</label>
                            <input required key="agency" type="text" class="form-control form-control-lg" v-model="investorProfile.DadosBancarios.Agencia" v-mask="'bank-account'" placeholder="Agência" >
                        </div>
                        <div v-if="investorProfile.DadosBancarios.CodigoBanco != '001' && investorProfile.DadosBancarios.CodigoBanco != '237'" class="col-12 col-lg-2">
                            <label for="agencia">Agência</label>
                            <input required key="agency-digit" type="text" class="form-control form-control-lg" v-model="investorProfile.DadosBancarios.Agencia" v-mask="'integer'" placeholder="Agência" >
                        </div>
                        <div class="col-12 col-lg-2">
                            <label for="inputPassword4">Conta</label>
                            <input required type="text" class="form-control form-control-lg" v-model="investorProfile.DadosBancarios.Conta" v-mask="'bank-account'" placeholder="Conta com dígito">
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>&nbsp;</label>
                            <div class="inline-radio">
                                <div class="form-check form-check-inline">
                                    <div class="checkContainer">
                                        <input class="form-check-input" type="radio" name="TipoConta" v-model.number="investorProfile.DadosBancarios.TipoConta" id="cc" value="1" required>
                                        <span class="checkmark"></span>
                                        <label class="form-check-label" for="cc">Conta corrente</label>
                                    </div>
                                </div>
                                <div class="form-check form-check-inline">
                                    <div class="checkContainer">
                                        <input class="form-check-input" type="radio" name="TipoConta" v-model.number="investorProfile.DadosBancarios.TipoConta" id="cp" value="2" required>
                                        <span class="checkmark"></span>
                                        <label class="form-check-label" for="cp">Conta poupança</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-12 bts">
                            <button type="submit" class="btn btn-primary btn-lg">
                                Atualizar
                            </button>
                        </div>
                    </div>
            </div>
        </section>
        </form>
    </div>
</template>

<style lang="scss" scoped>

.inline-radio .form-check input[data-v-835718a2] {
    top: 3.5px;
    margin-left: -1.1rem;
    padding: 0px;
}

.form-check-label {
    padding-left: 0;
    margin-bottom: 0;
}

.checkContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  padding-left: 30px;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
		  user-select: none;
		}

		&.checkTable {
			&{
				padding: 0;
			}

			input {
				height: 20px;
				width: 20px;
				left: 10px;
			}

			.checkmark {
				width: 20px;
				height: 20px;
				left: 10px;
			}
		}

		&.suitability {
			&{
				padding: 0;
				margin-left: -25px;
			}

			input {
				height: 20px;
				width: 20px;
				top: -10px;
			}

			.checkmark {
				top: -10px;
				width: 20px;
				height: 20px;
			}
		}

		label {
		  cursor: pointer;
		}

		input {
		  position: absolute !important;
		  opacity: 0;
		  cursor: pointer;
		  width: 25px;
		  height: 25px;
		  left: 20px;
		}

		.checkmark {
		  position: absolute;
		  top: 0;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 50%;
		  pointer-events: none;
		  border: 2px solid #ddd;

		  &::after {
			top: 9px;
			left: 9px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: white;
			pointer-events: none;
		  }
		}

		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	  }

	  .checkContainer input:checked ~ .checkmark {
		  background-color: #41d3bd;
	  }

	  .checkContainer input:checked ~ .checkmark:after {
		  display: block;
	  }


/* AT-UI OVERRIDE */
// SELECT
.at-select {
  &__selection {
    border-color: rgba(0,0,0,0.15) !important;
    line-height: 1.5 !important;
    font-size: 1.25rem !important;
    padding: .5rem 1rem !important;
    margin-bottom: 0.75em !important;
    box-sizing: content-box !important;

    &:hover {
      border-color: #888;
      box-shadow: none !important;
      outline: none;
    }
    &:focus {
      border-color: #888;
      box-shadow: none !important;
      outline: none;
    }
  }

  &--large {
      .at-select__dropdown {

           .at-select__list {
               margin-bottom: 0;
           }

          .at-select__option {
              &{
                font-size: 18px;
                padding: 10px 12px;
              }

              &--selected {
                  background-color: #41d3bd !important;
                  color: #fff !important;
              }
          }
      }
  }
}

.user-profile section label {
    text-transform: uppercase;
    font-size: 11px;
    font-size: .6875rem;
    font-weight: 700;
    color: #95989a;
    margin-bottom: 2px;
}

.user-profile section .btn-primary {
    background: #41d3bd;
    border: none;
    text-transform: uppercase;
    font-size: 18px;
    font-size: 1.125rem;
    font-weight: 700;
    padding: 10px 20px;
}

.margin {
  padding: 10px;
}
form {
  width: 100%;
  margin: 0px;
}
select {
  option {
    margin-left: 20px;
  }
}
.inline-radio {
  padding: 10px 0;
  .form-check {
    input {
      top: 3.5px;
      margin: 0px;
      padding: 0px;
    }
  }
}
.bts {
  margin-top: 40px;
}

.banco-principal {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;

  img {
    border-radius: 100px;
    width: 65px;
    height: 65px;
  }
}

.banco-principal-input {
  &:not(checked) ~ .banco-principal-logo {
    opacity: 0.1;
  }

  &:not(checked) {
    display: none;
    padding: 0px;
    margin: 0px;
  }

  &:checked ~ .banco-principal-logo {
    opacity: 1;
  }
}
</style>

<script>
/* eslint-disable */
import logoBancoDoBrasil from "../../static/assets/images/bancos/ico-bb.png";
import logoCaixa from "../../static/assets/images/bancos/ico-caixa.png";
import logoItau from "../../static/assets/images/bancos/ico-itau.png";
import logoBradesco from "../../static/assets/images/bancos/ico-bradesco.png";
import logoSantander from "../../static/assets/images/bancos/ico-santander.png";
import logoNeon from "../../static/assets/images/bancos/ico-neon.png";
import logoInter from "../../static/assets/images/bancos/ico-inter.png";

import Promise from "es6-promise";
import ApiClient from "@/utils/api-client";
import ApiClientGo from "@/utils/api-client-go";
import * as mutationTypes from "@/store/mutation-types.js";
import BankDataForm from "@/components/BankDataForm";
import StringHelper from "@/utils/string-helper";
import HubConsultaClient from '@/utils/hub-consulta-client';
import Masker from '@/utils/masker';


const Moip = window.Moip;

export default {
  components: {
    BankDataForm
  },
  data() {
    return {
      investorProfile: {},
      renderize: false,
      bankRenderizer: false,
      fullNameError: false,
      states: [
        { uf: "AC", nome: "Acre" },
        { uf: "AL", nome: "Alagoas" },
        { uf: "AP", nome: "Amapá" },
        { uf: "AM", nome: "Amazonas" },
        { uf: "BA", nome: "Bahia" },
        { uf: "CE", nome: "Ceará" },
        { uf: "DF", nome: "Distrito Federal" },
        { uf: "ES", nome: "Espírito Santo" },
        { uf: "GO", nome: "Goiás" },
        { uf: "MA", nome: "Maranhão" },
        { uf: "MT", nome: "Mato Grosso" },
        { uf: "MS", nome: "Mato Grosso do Sul" },
        { uf: "MG", nome: "Minas Gerais" },
        { uf: "PA", nome: "Pará" },
        { uf: "PB", nome: "Paraíba" },
        { uf: "PR", nome: "Paraná" },
        { uf: "PE", nome: "Pernambuco" },
        { uf: "PI", nome: "Piauí" },
        { uf: "RJ", nome: "Rio de Janeiro" },
        { uf: "RN", nome: "Rio Grande do Norte" },
        { uf: "RS", nome: "Rio Grande do Sul" },
        { uf: "RO", nome: "Rondônia" },
        { uf: "RR", nome: "Roraima" },
        { uf: "SC", nome: "Santa Catarina" },
        { uf: "SP", nome: "São Paulo" },
        { uf: "SE", nome: "Sergipe" },
        { uf: "TO", nome: "Tocantins" }
      ],
      cities: [],
      banks: [],
      agencia: "",
      mainBanks: [
        {
          codigo: "001",
          nome: "Banco do Brasil S.A.",
          logo: logoBancoDoBrasil
        },
        { codigo: "104", nome: "Caixa Econômica Federal", logo: logoCaixa },
        { codigo: "341", nome: "Itaú Unibanco S.A.", logo: logoItau },
        { codigo: "237", nome: "Banco Bradesco S.A.", logo: logoBradesco },
        {
          codigo: "033",
          nome: "Banco Santander (Brasil) S.A.",
          logo: logoSantander
        },
        { codigo: "735", nome: "Banco Neon", logo: logoNeon },
        { codigo: "077", nome: "Banco Intermedium S.A.", logo: logoInter }
      ]
    };
  },
  computed: {
    isOtherBank: {
      get: function() {
        return (
          this.mainBanks.find(bank => {
            return (
              bank.codigo == this.investorProfile.DadosBancarios.CodigoBanco
            );
          }) == null
        );
      },
      set: function() {
        this.investorProfile.DadosBancarios.CodigoBanco = "";
      }
    },
  },
  methods: {
    handleZipcodeChange(e) {
        if(Masker.unmaskZipcode(e.target.value).length < 8) return;

        HubConsultaClient.pegarCeps(e.target.value)
            .then(endereco => {
                this.investorProfile.Endereco.Logradouro = endereco.logradouro;
                this.investorProfile.Endereco.Bairro = endereco.bairro;
                this.investorProfile.Endereco.Uf = endereco.uf;
                this.investorProfile.Endereco.Cidade = endereco.localidade;

                this.cities = [];
                this.getCities();
            })
            .catch(() => {});
    },
    updateProfile() {
        if(!this.validationNames())
            return;

        this.$store.commit(mutationTypes.START_LOADING);

        this.validate().then(validation => {
                if(validation.isValid) {
                    this.investorProfile.DataNascimento = this.investorProfile.DataNascimentoExibicao;
                    this.investorProfile.RgDataEmissao = this.investorProfile.RgDataEmissaoExibicao;

                    ApiClient.updateProfile(this.investorProfile).then(result => {
                        this.$store.commit(mutationTypes.STOP_LOADING);
                        this.$Notify.info('Informações atualizadas com sucesso.');
                        ApiClientGo.atualizarContaBancaria(this.investorProfile.Cpf).then();
                    });
                } else {
                    this.$store.commit(mutationTypes.STOP_LOADING);

                    this.$Notify.error({
                        title: "Dados Bancários Inválidos",
                        message: validation.errors.map(error => error.replace(/\.\s([A-Z])/, (match, cg1) => `, ${cg1.toLowerCase()}`)).join(' ')
                    });
                }
            }
        );
    },
    validateFullName() {
      if (this.investorProfile.NomeCompleto[0] == " ") {
        this.investorProfile.NomeCompleto = "";
        return;
      }

      var splitText = this.investorProfile.NomeCompleto.split(" ");
      var upperCaseText = "";

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText +=
            splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.investorProfile.NomeCompleto = upperCaseText;
    },
    validateFathersName() {
        if(this.investorProfile.NomePai[0] == " ") {
          this.investorProfile.NomePai = "";
          return;
        }

        var splitText = this.investorProfile.NomePai.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
          if(splitText[i] != "") {
             if(i > 0)
              upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
          }
          else if(i > 0)
            upperCaseText += " ";
        }

        this.investorProfile.NomePai = upperCaseText;
    },
    validateMothersName() {
        if(this.investorProfile.NomeMae[0] == " ") {
            this.investorProfile.NomeMae = "";
            return;
        }

        var splitText = this.investorProfile.NomeMae.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
            if(splitText[i] != "") {
                if(i > 0)
                upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
            }
            else if(i > 0)
            upperCaseText += " ";
        }

        this.investorProfile.NomeMae = upperCaseText;
    },
    validationNames() {
        var splited = this.clearSplitNames(this.investorProfile.NomeCompleto.split(" "));

        if(splited.length <= 1) {
          this.$Notify.error("Preencha o seu nome completo.");
          return false;
        }

        return true;
    },
    clearSplitNames(splitName) {
        var cleanSplit = new Array();

        for(var i = 0; i < splitName.length; i++) {
          if(splitName[i] != "")
            cleanSplit.push(splitName[i])
        }

        return cleanSplit;
    },
    onUfChange() {
      this.cities = [];

      if (!this.investorProfile.Endereco.Uf) {
        this.investorProfile.Endereco.Cidade = "";
        return;
      }

      this.getCities();
    },
    getCities() {
      HubConsultaClient.pegarCidades(this.investorProfile.Endereco.Uf).then(
        cities => {
          this.cities = cities;

          if (this.investorProfile.Endereco.Cidade) {
            this.setCity();
          }

          var vm = this;
          vm.$refs.citySelect.$el.children[0].children[2].required = true;
          vm.$refs.nationalitySelect.$el.children[0].children[2].required = true;
          vm.$refs.placeOfBirthSelect.$el.children[0].children[2].required = true;
        }
      );
    },
    setCity() {
        var vm = this;
        const city = vm.cities.find(city => {
            return (
            StringHelper.removeAccents(city.nome.toUpperCase()) ==
            StringHelper.removeAccents(vm.investorProfile.Endereco.Cidade.toUpperCase()));
        });

        vm.investorProfile.Endereco.Cidade = "";

        if (city) {
            setTimeout(() => {
                vm.investorProfile.Endereco.Cidade = city.nome
            }, 100);
        }
    },
    aoMudarEhOutroBanco() {
      this.investorProfile.DadosBancarios.CodigoBanco = "";
    },
    submeterSemConta() {
      const newData = {
        bankData: null,
        hasNoAccount: true
      };
      this.$emit("submit", newData);
    },
    trimBankAccountStart(account, maxNumCount) {
      let splitedAccount = account.split("-");

      let len =
        splitedAccount.length > 1
          ? splitedAccount[0].length + splitedAccount[1].length
          : splitedAccount[0].length;

      let zeroCount = maxNumCount - len;
      let leftZero = "";

      for (let i = 0; i <= zeroCount; i++) {
        leftZero += "0";
      }

      let result = leftZero + account;
      console.log("leftZero + account: " + result);

      return leftZero + account;
    },
    validate() {
        var agencyCheckNumber = '';

      if(this.investorProfile.DadosBancarios.CodigoBanco == '001' || this.investorProfile.DadosBancarios.CodigoBanco == '237') {
        if(this.investorProfile.DadosBancarios.Agencia.split("-").length == 1) {
          var len = this.investorProfile.DadosBancarios.Agencia.length;
          this.investorProfile.DadosBancarios.Agencia =
            this.investorProfile.DadosBancarios.Agencia.slice(0, len - 1) + '-' + this.investorProfile.DadosBancarios.Agencia.slice(len - 1);
        }

        //banco do brasil e bradesco possuem dígito na agência
        agencyCheckNumber = this.investorProfile.DadosBancarios.Agencia.split("-")[1];
      }

      //banco do brasil e bradesco possuem dígito na agência
      agencyCheckNumber =
        this.investorProfile.DadosBancarios.CodigoBanco == "001" ||
        this.investorProfile.DadosBancarios.CodigoBanco == "237"
          ? this.investorProfile.DadosBancarios.Agencia.split("-")[1]
          : "";

      if (this.investorProfile.DadosBancarios.CodigoBanco == "001" ||
        this.investorProfile.DadosBancarios.CodigoBanco == "033")
        this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 8);
      else if (this.investorProfile.DadosBancarios.CodigoBanco == "237")
        this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 7);
      else if (this.investorProfile.DadosBancarios.CodigoBanco == "341")
        this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 5);

      return new Promise(resolve => {
        Moip.BankAccount.validate({
          bankNumber: this.investorProfile.DadosBancarios.CodigoBanco,
          agencyNumber: this.investorProfile.DadosBancarios.Agencia.split("-")[0],
          agencyCheckNumber: agencyCheckNumber,
          accountNumber: this.investorProfile.DadosBancarios.Conta.split("-")[0],
          accountCheckNumber: this.investorProfile.DadosBancarios.Conta.split("-")[1],
          valid: () => {
            resolve({ isValid: true, errors: [] });
          },
          invalid: data => {
            const errors = Array.map(data.errors, error => {
              return error.description;
            });
            resolve({ isValid: false, errors: errors });
          }
        });
      });
    },
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: 'perfil/editar-perfil',
        title: 'Editar',
      })
    },
  },
  async created() {
    if(this.$route.query.to === "bank") {
      setTimeout(() => {
        $("html, body").animate({ scrollTop: $(document).height()-$(window).height() });
      }, 100)
    }

    //tagueamento GA
    await this.taggingGA();
  },
  beforeCreate() {
    this.$store.commit(mutationTypes.START_LOADING);

    ApiClient.getInvestor()
      .then(investor => {
        this.banks = [];

        HubConsultaClient.pegarBancos().then(banks => {
            var vm = this;
            this.banks = banks;

            this.bankRenderizer = true
        });

        this.investorProfile = investor;
        this.agencia = this.investorProfile.DadosBancarios.Agencia;
        this.investorProfile.DataNascimentoExibicao = this.investorProfile.DataNascimento.toLocaleDateString("pt-BR");
        this.investorProfile.RgDataEmissaoExibicao = this.investorProfile.RgDataEmissao.toLocaleDateString("pt-BR");

        if(this.investorProfile.Nacionalidade !== 1 &&
            this.investorProfile.Nacionalidade !== 2 &&
            this.investorProfile.Nacionalidade !== 3) {
                this.investorProfile.Nacionalidade = "";
            }

        var possuiEstadoOndeNasceu = false;
        for (var i = 0; i < this.states.length; i++) {
            if(this.investorProfile.Naturalidade == this.states[i].nome) {
                possuiEstadoOndeNasceu = true;
                break;
            }
        }

        if(!possuiEstadoOndeNasceu)
            this.investorProfile.Naturalidade = "";

        if(this.investorProfile.RendaMensal.toString().indexOf(".") < 0)
            this.investorProfile.RendaMensal += ",00";

        if(this.investorProfile.Patrimonio.toString().indexOf(".") < 0)
            this.investorProfile.Patrimonio += ",00";

        this.getCities();

        this.renderize = true;

        this.$store.commit(mutationTypes.STOP_LOADING);
      })
      .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ProfileEdit.vue